import { useEffect, useState } from 'react';
import { X, UserPlus, Trash2 } from 'lucide-react';
import { projectsApi } from './useProjects';
import type { Member } from './api';

export function ShareDialog({ projectId, onClose }: { projectId: string; onClose: () => void }): JSX.Element {
  const [members, setMembers] = useState<Member[]>([]);
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<'editor' | 'viewer'>('editor');

  const refresh = () => projectsApi.members(projectId).then(setMembers);
  useEffect(() => { void refresh(); }, [projectId]); // eslint-disable-line react-hooks/exhaustive-deps

  async function invite() {
    if (!email.trim()) return;
    await projectsApi.share(projectId, email.trim(), role);
    setEmail(''); await refresh();
  }
  async function revoke(sub: string) { await projectsApi.revoke(projectId, sub); await refresh(); }

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-[rgba(0,0,0,0.4)]">
      <div className="w-[26rem] rounded-[12px] bg-[var(--color-surface)] p-4 shadow-[var(--shadow-2)] font-[var(--font-sans)]">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-sm font-medium text-[var(--color-text)]">Share project</h2>
          <button onClick={onClose} aria-label="Close" className="rounded-[6px] p-1 hover:bg-[var(--color-menu-hover)]"><X size={14} /></button>
        </div>
        <div className="mb-3 flex gap-2">
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && void invite()}
            placeholder="teammate@email.com"
            className="flex-1 rounded-[6px] bg-[var(--color-input-bg)] border border-[var(--color-input-border)] px-2 py-1 text-sm text-[var(--color-text)]"
          />
          <select
            value={role}
            onChange={(e) => setRole(e.target.value as 'editor' | 'viewer')}
            className="rounded-[6px] bg-[var(--color-input-bg)] border border-[var(--color-input-border)] px-1 text-sm text-[var(--color-text)]"
          >
            <option value="editor">Editor</option>
            <option value="viewer">Viewer</option>
          </select>
          <button
            onClick={() => void invite()}
            className="flex items-center gap-1 rounded-[6px] bg-[var(--color-accent)] px-2 py-1 text-sm text-white"
          >
            <UserPlus size={14} /> Invite
          </button>
        </div>
        <ul className="flex flex-col gap-1">
          {members.map((m) => (
            <li key={m.sub} className="flex items-center gap-2 px-2 py-1 text-sm text-[var(--color-text)]">
              <span className="flex-1">{m.invitedEmail ?? m.sub}</span>
              <span className="text-xs text-[var(--color-text-muted)]">{m.role}{m.status === 'invited' ? ' · invited' : ''}</span>
              {m.role !== 'owner' && (
                <button
                  onClick={() => void revoke(m.sub)}
                  aria-label="Revoke"
                  className="rounded-[6px] p-1 hover:bg-[var(--color-menu-hover)] text-[var(--color-danger)]"
                >
                  <Trash2 size={13} />
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
